import { render } from "./PendingRequests.vue?vue&type=template&id=75c5307e"
import script from "./PendingRequests.vue?vue&type=script&lang=js"
export * from "./PendingRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__